import { render } from "./NewsDetails.vue?vue&type=template&id=6d28151a&scoped=true"
import script from "./NewsDetails.vue?vue&type=script&lang=js"
export * from "./NewsDetails.vue?vue&type=script&lang=js"

import "./NewsDetails.vue?vue&type=style&index=0&id=6d28151a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d28151a"]])

export default __exports__